import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import {
  exportExcelFromApi,
  exportExcelLocal,
  exportFile,
} from "../../utils/tools";
import { formatDateToLocal } from "../../utils/utils";
import { useQueryClient } from "@tanstack/react-query";
import iconFile from "../../assets/images/apartment/Frame.svg";
import { totalCommissionCall } from "../../api/totalCommission";
import iconExcel from "../../assets/images/employee/iconExcel.svg";

const columnMappingReverse = {
  "Ngày thanh toán": "matchingDate",
  "Tháng đối chiếu": "monthYear",
  "Mã căn": "codeApartment",
  "Mã nhân viên": "codeSale",
  "Tên nhân viên": "nameSale",
  // Số tiền thanh toán đợt này = Số tiền thanh toán PDV + Thưởng nóng
  "Số tiền thanh toán PDV": "priceSale",
  "Thưởng nóng": "hotBonus",
  // Ghi chú (không bắt buộc): trống => tự ghi "Thanh toán ... PDV + ... thưởng nóng"
  "Ghi chú": "paymentNote",
  // Tên cột của các file mẫu trước vẫn import được
  "Số tiền PDV thanh toán": "priceSale",
  "Số tiền thanh toán": "priceSale",
  "Số tiền thanh toán thưởng nóng": "hotBonus",
};

export default function StepCommission() {
  const [paramExport, setParamExport] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupDeleteVisible, setPopupDeleteVisible] = useState(false);
  const queryClient = useQueryClient();
  // Refetch đúng query đang hiển thị của bảng (mọi biến thể filter/tháng/trang)
  // sau khi import/xoá — refetch của 1 instance hook không tác động instance khác.
  const refetch = () =>
    queryClient.invalidateQueries({ queryKey: ["totalCommission"] });

  // File xoá dùng chung cột với file import, chỉ cần Mã căn + Ngày thanh toán để
  // xác định đúng đợt cần xoá (1 đợt = 1 căn + 1 ngày).
  const handleExportDeleteSample = () => {
    const columnMapping = {
      matchingDate: "Ngày thanh toán",
      monthYear: "Tháng đối chiếu",
      codeApartment: "Mã căn",
      codeSale: "Mã nhân viên",
      nameSale: "Tên nhân viên",
      priceSale: "Số tiền thanh toán PDV",
    };

    const data = [
      {
        matchingDate: "07/07/2026",
        monthYear: "01/2026",
        codeApartment: "G.25.16",
        codeSale: "CTV001257",
        nameSale: "Nguyễn Duy Cường",
        priceSale: 768314,
      },
    ];

    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "Mẫu xoá đợt thanh toán.xlsx",
      toastMessages: {
        success: "Download file thành công",
      },
    });
  };

  const handleExportSample = () => {
    const columnMapping = {
      matchingDate: "Ngày thanh toán",
      monthYear: "Tháng đối chiếu",
      codeApartment: "Mã căn",
      codeSale: "Mã nhân viên",
      nameSale: "Tên nhân viên",
      priceSale: "Số tiền thanh toán PDV",
      hotBonus: "Thưởng nóng",
      paymentNote: "Ghi chú",
    };

    // Ví dụ minh hoạ:
    // - Cùng 1 căn G.25.16, thanh toán cùng ngày 07/07/2026 nhưng thuộc 2 Tháng
    //   đối chiếu khác nhau (01/2026 và 03/2026) → khách tách thành 2 dòng.
    //   Đây VẪN là 1 đợt thanh toán: trên màn hình mỗi NV hiển thị 1 dòng (gộp tiền),
    //   còn DB lưu tách theo Tháng ĐC (breakdown) để truy vết con số sau này.
    const data = [
      {
        matchingDate: "07/07/2026",
        monthYear: "01/2026",
        codeApartment: "G.25.16",
        codeSale: "CTV001257",
        nameSale: "Nguyễn Duy Cường",
        priceSale: 768314,
      },
      {
        matchingDate: "07/07/2026",
        monthYear: "03/2026",
        codeApartment: "G.25.16",
        codeSale: "CTV001257",
        nameSale: "Nguyễn Duy Cường",
        priceSale: 768313,
      },
      {
        matchingDate: "07/07/2026",
        monthYear: "01/2026",
        codeApartment: "G.25.16",
        codeSale: "CTV001336",
        nameSale: "Bùi Ngọc Linh",
        priceSale: 40500000,
        // Có thưởng nóng: số tiền thanh toán đợt này = 40.500.000 + 50.000.000 = 90.500.000.
        // Ghi chú để trống => tự ghi "Thanh toán 40.500.000 PDV + 50.000.000 thưởng nóng"
        hotBonus: 50000000,
        paymentNote: "",
      },
    ];
    // try {
    //   exportFile(data, columnMapping, "mau_import_dot_doi_chieu.xlsx");
    //   toast.success("Download file thành công");
    // } catch (error) {
    //   toast.error("Export lỗi");
    //   console.log(error);
    // }
    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "Mẫu import thanh toán PDV.xlsx",
      toastMessages: {
        success: "Download file thành công",
      },
    });
  };

  const handleExport = async () => {
    // ── Mapping MỚI khớp file mẫu khách "Bảng TH các đợt thanh toán".
    // Thứ tự cột do BE quyết định (thứ tự key trong mỗi dòng exportData).
    const checkInColumnMapping = {
      apartmentCode: "Mã lô",
      projectName: "Tên dự án",
      monthYear: "Đợt ĐC",
      code: "Mã NV",
      fullName: "Họ tên",
      totalServiceFee: "Tổng phí dịch vụ",
      deductionBeforeTax: "Khấu trừ trước thuế TNCN",
      personalIncomeTax: "Thuế TNCN",
      remainingRevenueAfterTax: "PDV sau thuế TNCN",
      periodPayment: "Đợt thanh toán",
      paymentDate: "Ngày thanh toán",
      paymentPercent: "Phần trăm đợt thanh toán",
      paymentAmount: "Số tiền thanh toán",
      remainingUnpaid: "PDV chưa thanh toán",
      // Tách "Số tiền thanh toán" (import) + ghi chú — chỉ để theo dõi
      pdvPaidAmount: "Số tiền thanh toán PDV",
      hotBonusPaidAmount: "Thưởng nóng",
      paymentNote: "Ghi chú",
    };

    /* ── MAPPING CŨ (giữ lại để dễ revert) ─────────────────────────────────
    const checkInColumnMappingOld = {
      apartmentCode: "Mã lô",
      projectName: "Tên dự án",
      paymentStatus: "Trạng thái thanh toán",
      totalAllCommissionPrice: "Tổng phí dịch vụ",
      totalRemainingRevenueAfterTax: "Tổng phí dịch vụ còn lại sau thuế",
      totalRemainingCommission: "Tổng phí dịch vụ còn lại",

      periodPayment: "Đợt thanh toán",
      paymentPercent: "Phần trăm đợt thanh toán",
      periodRemainingRevenueAfterTax:
        "Tổng PDV còn lại sau thuế trong đợt",

      code: "Mã NV",
      fullName: "Họ tên",
      saleBlock: "Khối",
      saleArea: "Vùng",
      commissionPrice: "PDV thanh toán",
      remainingRevenueAfterTax: "PDV còn lại sau thuế",
    };
    ─────────────────────────────────────────────────────────────────────── */

    await exportExcelFromApi({
      fetcher: () => totalCommissionCall.exportTotalCommission(paramExport),
      mapping: checkInColumnMapping,
      filename: "bang_th_cac_dot_thanh_toan.xlsx",
      autoFilter: true,
      toastMessages: {
        loading: "Đang tải dữ liệu & xuất file...",
        success: "Xuất file thành công",
        noData: "Không có dữ liệu",
        error: "Xuất file thất bại",
      },
    });
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý đợt thanh toán
          </Text>
        </Flex>
        <Flex gap={4}>
          <Flex alignItems={"center"} gap={"16px"}>
            <Button
              w={"240px"}
              h={"44px"}
              as={Button}
              backgroundImage="var(--color-button)"
              _hover={{
                filter: "brightness(96%)",
              }}
              onClick={() => setPopupVisible(true)}
              gap={"16px"}
              p={"10px 16px"}
            >
              <Flex alignItems={"center"} gap={"8px"}>
                <Image src={IconFile} />
                <Text
                  fontSize={{ base: "15px" }}
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Import đợt thanh toán
                </Text>
              </Flex>
            </Button>
          </Flex>
          <Flex alignItems={"center"} gap={"16px"}>
            <Button
              w={"240px"}
              h={"44px"}
              as={Button}
              bg={"#E53E3E"}
              _hover={{
                filter: "brightness(96%)",
              }}
              onClick={() => setPopupDeleteVisible(true)}
              gap={"16px"}
              p={"10px 16px"}
            >
              <Flex alignItems={"center"} gap={"8px"}>
                <Image src={IconFile} />
                <Text
                  fontSize={{ base: "15px" }}
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Xoá đợt thanh toán
                </Text>
              </Flex>
            </Button>
          </Flex>
          <Flex alignItems={"center"} gap={"16px"}>
            <Button
              display={"flex"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              h={"44px"}
              backgroundImage="var(--linear-gradient-excel)"
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={handleExport}
            >
              <Image src={iconExcel} />
              <Text
                fontSize={{ base: "15px" }}
                fontWeight={600}
                color="var(--color-main)"
              >
                Xuất thông tin thanh toán
              </Text>
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableLocking setParamExport={setParamExport} />
      </Box>

      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm đợt thanh toán"
          inputAdd="Nhập danh sách đợt thanh toán"
          type={"importTotalCommission"}
          isTypePrice={true}
          requiredCheck={true}
        />
      )}

      {popupDeleteVisible && (
        <PopupImport
          isOpen={popupDeleteVisible}
          onClose={() => setPopupDeleteVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportDeleteSample}
          titleAdd="Xoá đợt thanh toán"
          inputAdd="Xoá danh sách đợt thanh toán đã import"
          type={"deleteTotalCommission"}
          isTypePrice={true}
          requiredCheck={true}
          titleCheck="Kiểm tra dữ liệu xoá"
        />
      )}
    </Box>
  );
}
